import { render, staticRenderFns } from "./leftsinmenupromotor.vue?vue&type=template&id=ed3c28c0&"
import script from "./leftsinmenupromotor.vue?vue&type=script&lang=js&"
export * from "./leftsinmenupromotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports